// Upload helper utilities for progress tracking and callbacks

/**
 * Factory function to create standardized progress callbacks for upload tracking
 * @param {Object} store - Vuex store instance
 * @param {string} uploadId - The upload ID to track progress for
 * @returns {Function} Progress callback function
 */
export const createProgressCallback = (store, uploadId) => {
  return progress => {
    store.dispatch('uploadProgress/updateUpload', {
      id: uploadId,
      data: {
        progress: progress,
        status: getUploadStatus(progress),
        message: getUploadMessage(progress)
      }
    });
  };
};

/**
 * Standard upload status messages
 */
export const UPLOAD_MESSAGES = {
  PREPARING: 'Preparing upload...',
  UPLOADING: 'Uploading to storage...',
  COMPLETED: 'Upload completed!',
  ERROR: 'Upload failed. Please try again.'
};

/**
 * Upload progress thresholds
 */
export const UPLOAD_THRESHOLDS = {
  CRITICAL_PHASE: 33, // Below this = critical phase (gatekeeping applies)
  SEAMLESS_PHASE: 33, // Above this = seamless phase (no gatekeeping)
  COMPLETED: 100
};

/**
 * Get upload status based on progress
 * @param {number} progress - Progress percentage (0-100)
 * @returns {string} Status string
 */
export const getUploadStatus = progress => {
  if (progress >= UPLOAD_THRESHOLDS.COMPLETED) return 'completed';
  if (progress >= UPLOAD_THRESHOLDS.SEAMLESS_PHASE) return 'uploading';
  return 'preparing';
};

/**
 * Get upload message based on progress
 * @param {number} progress - Progress percentage (0-100)
 * @returns {string} Message string
 */
export const getUploadMessage = progress => {
  if (progress >= UPLOAD_THRESHOLDS.COMPLETED) return UPLOAD_MESSAGES.COMPLETED;
  if (progress >= UPLOAD_THRESHOLDS.SEAMLESS_PHASE) return UPLOAD_MESSAGES.UPLOADING;
  return UPLOAD_MESSAGES.PREPARING;
};
